import BusinessListWidget from "@components/widgets/BusinessListWidget";
import BusinessesAtPropertyWidget from "@components/widgets/BusinessesAtPropertyWidget";
import CalendarWidget from "@components/widgets/CalendarWidget";
import ContactListWidget from "@components/widgets/ContactListWidget";
import EcDevStatWidget from "@components/widgets/EcDevStatWidget";
import NotesWidget from "@components/widgets/NotesWidget";
import OverviewStatWidget from "@components/widgets/OverviewStatWidget";
import PropertiesByOwnerWidget from "@components/widgets/PropertiesByOwnerWidget";
import TodoWidget from "@components/widgets/TodoWidget";
import WorkPlanListWidget from "@components/widgets/WorkPlanListWidget";
import WorkPlanTaskListWidget from "@components/widgets/WorkPlanTaskListWidget";
import WorkPlanTasksWidget from "@components/widgets/WorkPlanTasksWidget";

export const supportedWidgets = {
    contact: {
        /*committee: {
            name: 'Committee',
            desc: 'Display a list of contacts that are members of a committee.'
        },*/
        list: {
            name: 'Contact List',
            desc: 'Display names and phone numbers from a list of chosen contacts.',
            options: ['contacts'],
            widget: ContactListWidget,
            w: 4,
            h: 2,
        }
    },
    workplan: {
        single: {
            name: 'Work Plan (Tasks)',
            desc: 'Display the tasks for a specified work plan.',
            options: ['workplan'],
            widget: WorkPlanTasksWidget,
            w: 4,
            h: 2,
        },
        list: {
            name: 'Work Plan List',
            desc: 'Display overview information from a list of chosen work plans.',
            options: ['workplans'],
            widget: WorkPlanListWidget,
            w: 4,
            h: 2,
        },
        tasklist: {
            name: 'Task List',
            desc: 'Display a list of upcoming and past due tasks for all work plans or for a specific person.',
            widget: WorkPlanTaskListWidget,
            w: 4,
            h: 2,
            // Options are handled manually because this widget is unique
        }
    },
    business: {
        list: {
            name: 'Business List',
            desc: 'Display overview information from a list of chosen businesses.',
            options: ['businesses'],
            widget: BusinessListWidget,
            w: 4,
            h: 2,
        }
    },
    property: {
        address: {
            name: 'Address',
            desc: 'Display a list of all of the businesses attached to a property.',
            options: ['property'],
            widget: BusinessesAtPropertyWidget,
            w: 4,
            h: 2,
        },
        owner: {
            name: 'Owner',
            desc: 'Display a list of all of the businesses owned by a chosen contact/business.',
            options: ['contact', 'business', 'contact_or_business_radio'],
            widget: PropertiesByOwnerWidget,
            w: 4,
            h: 2,
        }
    },
    misc: {
        notes: {
            name: 'Notes',
            desc: 'Enter and save notes or todo-lists.',
            widget: NotesWidget,
            w: 4,
            h: 2,
        },
        overview: {
            name: 'Overview',
            desc: 'Display usage statistics about Maestro.',
            widget: OverviewStatWidget,
            w: 6,
            h: 1,
        },
        ecdev: {
            name: 'Economic Development',
            desc: 'Display economic development statistics about your community.',
            widget: EcDevStatWidget,
            w: 6,
            h: 1,
        },
        todo: {
            name: 'Todo',
            desc: 'Display a simple todo list.',
            options: ['name'],
            widget: TodoWidget,
            w: 2,
            h: 4,
        },
        calendar: {
            name: 'Calendar',
            desc: 'Display a simple calendar.',
            widget: CalendarWidget,
            w: 6,
            h: 6,
        }
    }
};
